module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvaWNvbnMvZmF2aWNvbi0zMngzMi5wbmciOw=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/favicon-32x32.png
// module id = uLpg
// module chunks = 0